// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-AppDocuments-AppDocuments-module__container--1k5c3","header":"src-components-AppDocuments-AppDocuments-module__header--1BZkq"};